export default class FormAnimation {
  constructor(el) {
    this.$el = $(el);
    this.activeFocus = 'active-focus';

    this.elementClasses = {
      formGroup: '.gfield',
      formControl: 'input, textarea',
    };
    this.init();
  }

  init() {
    if (this.$el.length) {
      this.checkValue();
      this.addEventListeners();
    }
  }

  addEventListeners() {
    this.formFocus();
    this.formChange();
    this.documentClick();
  }

  checkValue() {
    this.$el.find(this.elementClasses.formControl).each((_index, el) => {
      const eleParent = $(el).parents(this.elementClasses.formGroup);
      if ($(el)[0].value.length) {
        eleParent.addClass(this.activeFocus);
      } else {
        eleParent.removeClass(this.activeFocus);
      }
    });
  }

  formFocus() {
    this.$el.find(this.elementClasses.formGroup).on('focus', this.elementClasses.formControl, this.formFocusEvent.bind(this));
    this.$el.find(this.elementClasses.formGroup).on('focusout', this.elementClasses.formControl, () => {
      this.checkValue();
    });
  }

  formFocusEvent(e) {
    const ele = e.currentTarget;
    this.checkValue();
    $(ele).parents(this.elementClasses.formGroup).addClass(this.activeFocus);
  }

  formChange() {
    this.$el.find(this.elementClasses.formGroup).on('change', this.elementClasses.formControl, () => {
      this.checkValue();
    });
  }

  documentClick() {
    $(document).on('click focus', (e) => {
      const ele = e.target;
      if (!$(ele).is('.ginput_container input, .ginput_container textarea')) {
        this.checkValue();
      }
    });
  }
}
